import { Card, CardBody } from "reactstrap";
import { HorizontalBar } from 'react-chartjs-2';
import { backgroundColorList } from "services/Utils";
import { borderColorList } from "services/Utils";

export default function PorPrazo({ dados }) {
  return (
    <Card className="mt-4">
      <CardBody>

        <HorizontalBar
          data={{
            labels: dados.map(el => el.label),
            datasets: [
              {
                data: dados.map(el => el.quantidade),
                backgroundColor: dados.map((_, i) => backgroundColorList[i]),
                borderColor: dados.map((_, i) => borderColorList[i]),
                borderWidth: 1,
              },
            ]
          }}
          options={{
            title: {
              display: true,
              text: "Ordens de Serviço por Prazo"
            },
            legend: {
              labels: false
            },
            scales: {
              xAxes: [
                { stacked: true }
              ],
              yAxes: [
                { stacked: true }
              ]
            }

          }}
        />


      </CardBody>
    </Card>
  )
}